(() => {
  const node = document.querySelector('[data-product-bundle]');
  const defaultPriceMessage = node.querySelector('[data-total-price]').innerHTML;
  const bundleMinimumItems = parseInt(node.dataset.productBundleMinimumItems);
  const bundleLimit = parseInt(node.dataset.productBundleLimit);
  const initialDiscount = parseInt(node.dataset.productBundleInitialDiscount);
  const bundleParentId = parseInt(node.dataset.parentBundleId);

  const productJson = window.document.URL+".json";
  let isPartnerProduct = false;
  fetch(productJson)
      .then((response) => response.json())
      .then((data) => {
        const tags = data.product.tags;
        if (tags.includes("partner_product")){
          isPartnerProduct = true
        }
      })
      .catch(console.error);

  const country = window.Shopify?.shop;

  let DISCOUNTS,
      staticBundle = false;


  if (bundleLimit === 1  && bundleMinimumItems === 1) {
    let staticBundle = true
  }

  if (bundleLimit > 0) {
    DISCOUNTS = [
      {
        minimumItems: bundleMinimumItems,
        amount: initialDiscount,
        step: 1,
      },
    ];
  } else {
    DISCOUNTS = [
      {
        minimumItems: 5,
        amount: 10,
        step: 1,
      },
      {
        minimumItems: 9,
        amount: 15,
        step: 2,
      },
      {
        minimumItems: 14,
        amount: 25,
        step: 3,
      },
    ];
  }

  if (country === 'nupo-ro.myshopify.com'){
    if (bundleLimit > 0) {
      DISCOUNTS = [
        {
          minimumItems: bundleMinimumItems,
          amount: initialDiscount,
          step: 1,
        },
      ];
    } else {
      DISCOUNTS = [
        {
          minimumItems: 7,
          amount: 7,
          step: 1,
        },
        {
          minimumItems: 12,
          amount: 11,
          step: 2,
        },
        {
          minimumItems: 15,
          amount: 18,
          step: 3,
        },
      ];
    }
  }

  if (country === 'nupo-se.myshopify.com' || country === 'nupo-de.myshopify.com' || country === 'nupo-test.myshopify.com' || country === 'nupo-com.myshopify.com'){
    if (bundleLimit > 0) {
      DISCOUNTS = [
        {
          minimumItems: bundleMinimumItems,
          amount: initialDiscount,
          step: 1,
        },
      ];
    } else {
      DISCOUNTS = [
        {
          minimumItems: 5,
          amount: 5,
          step: 1,
        },
        {
          minimumItems: 9,
          amount: 10,
          step: 2,
        },
        {
          minimumItems: 14,
          amount: 15,
          step: 3,
        },
      ];
    }
  }

  const percCont = document.querySelector('.product-mix-bundle__percentage-container');
  if (bundleLimit === 0) {
    percCont.classList.remove("hidden");
  }

  const stickyCta = () => {
    const bundleCta = node.querySelector('[data-bundle-cta]');
    const stickyCta = document.querySelector('[data-sticky-cta]');

    new IntersectionObserver(([entry]) => {
      stickyCta.classList.toggle('product-bundle__sticky--active', !entry.isIntersecting);
    }, {
      root: null,
      rootMargin: '0px',
      threshold: 0
    }).observe(bundleCta);
  };

  const activeProductItem = (qty, item, qtySelector) => {
    const isActive = qty.dataset.value > 0;
    item.classList.toggle('product-bundle__item--active', isActive);
    qtySelector.classList.toggle('product-bundle__item__quantity-selector--active', isActive);
  };

  const updateQuantity = (qty, value) => {
    const maxQuantity = parseInt(qty.dataset.maxQuantity);
    const item = qty.closest('.product-bundle__item');
    const qtySelector = item.querySelector('.product-bundle__item__quantity-selector');
    const incrementButton = qtySelector.querySelector('[data-increment]');
    // const deSelector = qtySelector.querySelector('[data-deselector]');
    const totalQty = getTotalQty() - parseInt(qty.dataset.value);
    if (bundleLimit === 0 || totalQty + value <= bundleLimit) {
      qty.dataset.value = value;
      qty.textContent = value;

      activeProductItem(qty, item, qtySelector);
      incrementButton.classList.toggle('product-bundle__item__quantity-selector__button--disabled', value >= maxQuantity);
      /*deSelector.toggleAttribute("hidden", value === 0)*/
      updatePrice();
      updateMinimumAmount();
      updateTotalAmountQty();
      updateCta();
      mealCalculation();
    }

    if (staticBundle){
      qty.dataset.value = '1';
      qty.textContent = 1;
    }
  };

  const qtyDecrement = (qty) => {
    const currentValue = parseInt(qty.dataset.value);
    if (currentValue > 0) {
      updateQuantity(qty, currentValue - 1);
    }
  };

  const qtyIncrement = (qty) => {
    const currentValue = parseInt(qty.dataset.value);
    const maxQuantity = parseInt(qty.dataset.maxQuantity);
    const totalQty = getTotalQty() - currentValue;

    if (currentValue < maxQuantity && (bundleLimit === 0 || totalQty <= bundleLimit)) {
      updateQuantity(qty, currentValue + 1);
    }
  };

  const getTotalQty = () => {
    return Array.from(node.querySelectorAll('.product-bundle__item--active [data-quantity]'))
        .reduce((acc, qty) => acc + parseInt(qty.dataset.value), 0);
  };

  const selectItem = () => {
    document.querySelectorAll('.product-bundle__item').forEach(item => {
      item.addEventListener('click', () => {
        const qty = item.querySelector('[data-quantity]');
        if (parseInt(qty.dataset.value) === 0) {
          updateQuantity(qty, 1);
        }
      });
    });
  };

  const hitImage = () => {
    document.querySelectorAll('.product-bundle__item__image-wrapper').forEach(item => {
      item.addEventListener('click', () => {
        const aa = item.nextElementSibling;
        const bb = aa.nextElementSibling;
        const qty = bb.querySelector('[data-quantity]');
        const currentValue = parseInt(qty.dataset.value);
        updateQuantity(qty, currentValue + 1);
      });
    });
  }

  const removeItem = (item) => {
    const qty = item.querySelector('[data-quantity]');
    updateQuantity(qty, 0);
  };

  const updatePrice = () => {
    const activeItems = Array.from(node.querySelectorAll('.product-bundle__item--active [data-product]'));
    const totalQty = activeItems.reduce((acc, product) => acc + parseInt(product.closest('.product-bundle__item').querySelector('[data-quantity]').dataset.value), 0);
    const currentDiscount = (DISCOUNTS.filter((discount) => totalQty >= discount.minimumItems && discount.amount > 0)?.pop() || null);
    const discountFraction = (currentDiscount?.amount || 0) / 100;


    const total = activeItems.reduce((acc, product) => {
      const productData = JSON.parse(product.textContent);
      const price = parseFloat(productData.price);
      const qty = parseInt(product.closest('.product-bundle__item').querySelector('[data-quantity]').dataset.value);
      return (!isNaN(price) && !isNaN(qty)) ? acc + price * qty * (1 - discountFraction) : acc;
    }, 0) / 100;

    const regex = /{{(.*?)}}/;
    const match = regex.exec(window.bundleStrings.currency_rules);
    const extractedStringWhite = match[1];
    const extractedString = extractedStringWhite.replaceAll(' ', '');

    let formattedTotalWithCurrency = ''
    let formattedTotal = ''
    let formattedTotalWithCurrencyDiscount = ''
    if (extractedString === 'amount_with_comma_separator'){
      formattedTotal = total.toLocaleString('da-DK', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      formattedTotalWithCurrency = window.bundleStrings.currency_rules.replace('{{amount_with_comma_separator}}', formattedTotal);
    }
    if (extractedString === 'amount_no_decimals_with_space_separator'){
      formattedTotal = total.toLocaleString('cs', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
      formattedTotalWithCurrency = window.bundleStrings.currency_rules.replace('{{ amount_no_decimals_with_space_separator }}', formattedTotal);
    }

    if (extractedString === 'amount_no_decimals'){
      formattedTotal = total.toLocaleString('se-SV', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      formattedTotalWithCurrency = window.bundleStrings.currency_rules.replace('{{amount_no_decimals}}', formattedTotal);
    }

    if (extractedString === 'amount'){
      formattedTotal = total.toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      /*if (bundleParentId === 41231254192193){*/
      if (isPartnerProduct){
        formattedTotal = 0
      }
      formattedTotalWithCurrency = window.bundleStrings.currency_rules.replace('{{amount}}', formattedTotal);
    }
    const threshold = bundleMinimumItems > 0 ? bundleMinimumItems : 5;

    Array.from(document.querySelectorAll('[data-total-price]')).forEach((element) => {
      element.innerHTML = `${formattedTotalWithCurrency}`; /*total === 0 ? defaultPriceMessage : `${formattedTotalWithCurrency}`;*/
      element.classList.toggle('product-bundle__price--discount', totalQty >= threshold);
    });

    const productTitle = document.querySelector('.product-bundle__title').textContent

    if (!productTitle.includes('LIGHTCOM')) {
      Array.from(document.querySelectorAll('[data-compare-price]')).forEach((comparePriceElement) => {
        comparePriceElement.classList.toggle('product-bundle__price-compare--active', totalQty >= threshold);
        if (totalQty >= threshold) {
          if (extractedString === 'amount_with_comma_separator') {
            let formattedTotalDiscounbt = (total / (1 - discountFraction)).toLocaleString('da-DK', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });
            formattedTotalWithCurrencyDiscount = window.bundleStrings.currency_rules.replace('{{amount_with_comma_separator}}', formattedTotalDiscounbt);
          }
          if (extractedString === 'amount_no_decimals') {
            let formattedTotalDiscounbt = (total / (1 - discountFraction)).toLocaleString('se-SV', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });
            formattedTotalWithCurrencyDiscount = window.bundleStrings.currency_rules.replace('{{amount_no_decimals}}', formattedTotalDiscounbt);
          }
          if (extractedString === 'amount') {
            let formattedTotalDiscounbt = (total / (1 - discountFraction)).toLocaleString('en-GB', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });
            formattedTotalWithCurrencyDiscount = window.bundleStrings.currency_rules.replace('{{amount}}', formattedTotalDiscounbt);
          }
          if (extractedString === 'amount_no_decimals_with_space_separator') {
            let formattedTotalDiscounbt = (total / (1 - discountFraction)).toLocaleString('cs', {
              minimumFractionDigits: 0,
              maximumFractionDigits: 0
            });
            formattedTotalWithCurrencyDiscount = window.bundleStrings.currency_rules.replace('{{ amount_no_decimals_with_space_separator }}', formattedTotalDiscounbt);
          }
          comparePriceElement.textContent = `${formattedTotalWithCurrencyDiscount}`;
        }
      });

      Array.from(document.querySelectorAll('[data-discount-percentage]')).forEach((discountPercentageElement) => {

        const discFirst = document.querySelector('[data-discount-first]');
        const discSecond = document.querySelector('[data-discount-second]');
        const discThird = document.querySelector('[data-discount-third]');

        percCont.classList.toggle('light',totalQty < threshold);

        if (bundleLimit > 0 && totalQty >= threshold) {
          discountPercentageElement.classList.toggle('product-bundle__percentage--active', totalQty >= threshold);
          discountPercentageElement.textContent = `${Math.round(discountFraction * 100)}%`;
        } else {
          discFirst.classList.toggle('product-mix-bundle__percentage--active', discountFraction === 0.1);
          discSecond.classList.toggle('product-mix-bundle__percentage--active', discountFraction === 0.15);
          discThird.classList.toggle('product-mix-bundle__percentage--active', discountFraction === 0.25);
        }
      });
    }
  };

  const updateMinimumAmount = () => {
    const totalQty = Array.from(node.querySelectorAll('.product-bundle__item--active [data-quantity]'))
        .reduce((acc, qty) => acc + parseInt(qty.dataset.value), 0);
    const currentDiscount = (DISCOUNTS.filter((discount) => totalQty >= discount.minimumItems && discount.amount > 0)?.pop() || null);
    const nextDiscount = currentDiscount ? DISCOUNTS[DISCOUNTS.indexOf(currentDiscount) + 1] : DISCOUNTS.find((discount) => discount.amount > 0);

    let message;
    if (bundleLimit > 0) {
      if (bundleLimit - totalQty === 0) {
        const discountPercentageElement = document.querySelector('[data-discount-percentage]');
        let discountPercentage = discountPercentageElement.textContent;
        discountPercentage = discountPercentage.replace("%", "");
        discountPercentage = parseInt(discountPercentage, 10);

        const productTitle = document.querySelector('.product-bundle__title').textContent

        /*if (bundleParentId === 41231254192193){*/
        if (isPartnerProduct){
          message = 'You have selected 15 items. Please continue to checkout'
        } else {
          message = window.bundleStrings.receivingDiscount.replace('%%DISCOUNT%%', discountPercentage);
        }

      } else {
        message = window.bundleStrings.selectAtLeastXItems.replace("%%ITEMS%%", bundleLimit - totalQty);
      }
    } else {
      message = nextDiscount
          ? window.bundleStrings.selectXMoreItemsToGetYDiscount
              .replace("%%ITEMS%%", nextDiscount.minimumItems - totalQty)
              .replace("%%DISCOUNT%%", nextDiscount.amount)
          : window.bundleStrings.receivingDiscount.replace("%%DISCOUNT%%", currentDiscount.amount);
    }

    const discountStepMessage = window.bundleStrings.discountStep.replace('%%STEP%%', (currentDiscount || DISCOUNTS[0]).step);

    const updateElement = (element, textClass, stickyClass, message) => {
      const hasDiscount = totalQty >= bundleMinimumItems;

      element.parentElement.classList.toggle('product-bundle__select--discount', hasDiscount);

      if (element.classList.contains(stickyClass)) {
        element.classList.toggle(`${stickyClass}--discount`, hasDiscount);
      }

      element.textContent = message;
    };

    Array.from(document.querySelectorAll('[data-minimum-amount]')).forEach((minimumElement) => {
      updateElement(
          minimumElement,
          'product-bundle__select__text', 'product-bundle__sticky__select__text',
          message,
      );
    });

    Array.from(document.querySelectorAll('[data-discount-step]')).forEach((discountStep) => {
      updateElement(
          discountStep,
          'product-bundle__select__discount-step', 'product-bundle__sticky__select__discount-step',
          discountStepMessage,
      );
    });
  };

  const updateTotalAmountQty = () => {

    const totalQty = Array.from(node.querySelectorAll('.product-bundle__item--active [data-quantity]'))
        .reduce((acc, qty) => acc + parseInt(qty.dataset.value), 0);

    const replacedMessage = window.bundleStrings.xItemsSelected.replace('%%ITEMS%%', totalQty);

    Array.from(document.querySelectorAll('[data-total-selected-amount]'))
        .forEach((element) => {
          element.textContent = totalQty;
        });

    // Update data-item-count element
    const itemCountElement = document.querySelector('[data-item-count]');
    if (itemCountElement) {
      const originalText = itemCountElement.textContent.replace(/\(\d+\)$/, '').trim(); // Remove the number at the end
      itemCountElement.textContent = totalQty > 0 ? `${originalText} (${totalQty})` : originalText;
    }
  };

  const mealCalculation = () => {
    const totalMeals = Array.from(node.querySelectorAll('.product-bundle__item--active [data-product]'))
        .reduce((acc, product) => {
          const productData = JSON.parse(product.textContent);
          const meals = parseInt(productData.meals);
          const qty = parseInt(product.closest('.product-bundle__item').querySelector('[data-quantity]').dataset.value);

          if (!isNaN(meals) && !isNaN(qty)) {
            return acc + meals * qty;
          } else {
            return acc;
          }
        }, 0);
    const mealCount = Math.floor(totalMeals / 6);
    const extraMeals = totalMeals % 6;
    const message = window.bundleStrings.mealCount;
    const replacedMessage = message.replace('%%DAYS%%', mealCount).replace('%%EXTRA%%', extraMeals);

    Array.from(document.querySelectorAll('[data-meals-count]'))
        .forEach((element) => {
          if (mealCount > 0 || extraMeals > 0){
            element.classList.remove('hidden');
            element.textContent = replacedMessage;
          } else {
            element.classList.add('hidden');
          }
        });
  };

  const updateCta = () => {
    const totalQty = Array.from(node.querySelectorAll('.product-bundle__item--active [data-quantity]'))
        .reduce((acc, qty) => acc + parseInt(qty.dataset.value), 0);

    const threshold = bundleMinimumItems > 0 ? bundleMinimumItems : 1;

    Array.from(document.querySelectorAll('[data-bundle-cta]')).forEach(cta => {
      const label = cta.querySelector('[data-bundle-cta-label]');

      const isActive = totalQty >= threshold;
      cta.classList.toggle('product-bundle__cta--active', isActive);
      label.textContent = window.bundleStrings[isActive ? 'addToCart' : 'chooseFlavors'];
    });
  };

  const addToCart = () => {
    const cartDrawer = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const items = Array.from(node.querySelectorAll('.product-bundle__item--active [data-product]')).map((product) => {
      const productData = JSON.parse(product.textContent);
      const qty = parseInt(product.closest('.product-bundle__item').querySelector('[data-quantity]').dataset.value);

      /*Becomes true if Lightcom is in the cart */
      /*const itemsInCart = window.cart.items
      const checkForProduct = obj => obj.product_id === 7246668169281;*/
      /*if (bundleParentId === 41231254192193){*/
      if (isPartnerProduct){
        setTimeout(() => {
          location.reload()
        }, 2500)
      }

      return {
        id: productData.id,
        quantity: qty,
        properties: {
          "__bundle": bundleParentId
        }
      };
    });

    const totalQty = items.reduce((total, item) => total + item.quantity, 0);
    const threshold = bundleMinimumItems > 0 ? bundleMinimumItems : 1;

    if (totalQty < threshold) {
      return; // Exit the function if the total quantity is less than the threshold
    }

    const data = {
      items: items
    };


    const config = fetchConfig('json');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';

    if (cartDrawer) {
      data.sections = cartDrawer.getSectionsToRender().map((section) => section.id);
      data.sections_url = window.location.pathname;
      cartDrawer.setActiveElement(document.activeElement);
    }

    config.body = JSON.stringify(data);


    fetch(window.routes.cart_add_url + `.js`, config)
        .then(response => response.json())
        .then(data => {

          if (cartDrawer) {
            cartDrawer.classList.remove('is-empty');
            cartDrawer.renderContents(data);
          }
        })
        .catch((error) => {
          console.error('Error:', error);
        });
  };

  const init = () => {
    stickyCta();
    selectItem();
    hitImage();

    node.querySelectorAll('[data-remove-item]').forEach((removeButton) => {
      removeButton.addEventListener('click', (event) => {
        event.stopPropagation();
        removeItem(removeButton.closest('.product-bundle__item'));
      });
    });

    node.querySelectorAll('[data-quantity]').forEach((qty) => {
      const parent = qty.closest('.product-bundle__item__quantity-selector');
      const decrease = parent.querySelector('[data-decrement]');
      const increase = parent.querySelector('[data-increment]');

      decrease.addEventListener('click', (event) => {
        event.stopPropagation();
        qtyDecrement(qty);
      });

      increase.addEventListener('click', () => qtyIncrement(qty));
    });

    document.querySelectorAll('[data-bundle-cta]').forEach((cta) => {
      cta.addEventListener('click', addToCart);
    });
  };

  init();
})();
